const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string);


export default isNumeric;
